import { type ReactNode } from 'react'
import { cn } from '#app/utils/misc.tsx'

// A standardized "abstract" for a Writing: the hard problem it solves, and the
// approach that answers it. Sits at the top of the page so a skim-reader gets the
// five-second version before the essay or demo begins. Consistent shape across
// every post is intentional — it becomes a signature and mirrors the site's
// thesis (structured inputs -> derived artifact).
//
// Rendered by ArticleLayout for essays and DemoCapsule for demos; nobody places
// it by hand. `className` exists because the demo pages are wide (max-w-4xl) flex
// columns with their own gap, so they override the default margin and cap the
// measure — full-bleed rows here would run to ~140 characters.
export function ProblemCapsule({
	problem,
	approach,
	className,
}: {
	problem: ReactNode
	approach: ReactNode
	className?: string
}) {
	return (
		<div
			className={cn(
				'not-prose border-border bg-muted/30 my-8 overflow-hidden rounded-lg border',
				className,
			)}
		>
			<Row label="Hard problem">{problem}</Row>
			<div className="border-border border-t">
				<Row label="Approach">{approach}</Row>
			</div>
		</div>
	)
}

function Row({ label, children }: { label: string; children: ReactNode }) {
	return (
		<div className="flex flex-col gap-1 px-4 py-3 sm:flex-row sm:gap-4">
			<div className="text-muted-foreground shrink-0 text-xs font-medium tracking-wide uppercase sm:w-28 sm:pt-0.5">
				{label}
			</div>
			<div className="text-foreground text-sm text-pretty">{children}</div>
		</div>
	)
}
